import { Component, OnInit, Input } from '@angular/core';

import { QuestionSet } from '../../shared/models/question-set';


@Component({
  selector: 'app-question-set-core-form',
  templateUrl: './question-set-core-form.component.html',
  styleUrls: ['./question-set-core-form.component.css']
})
export class QuestionSetCoreFormComponent implements OnInit {

  @Input() private questionSet:QuestionSet;

  constructor() { }

  ngOnInit() {
  }

  public get QuestionSet() {
    return this.questionSet;
  }

  public set QuestionSet(v:QuestionSet) {
    this.questionSet = v;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/question-set-core-form/question-set-core-form.component.ts